module.exports = __webpack_public_path__ + "static/media/w4-t.100be598.jpg";